export const unmountedStyleModal = {
    opacity: 0,
    top: '100vh',
    transition: 'all 700ms ease-in',
    zIndex: 0,
};

export const mountedStyleModal = {
    opacity: 1,
    bottom: '100vh',
    transition: 'all 400ms ease-in',
    zIndex: 0,
};